import * as moment from 'moment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroListaSolicitacaoCompra } from '../filter/filtro-lista-solicitacao-compra';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { SolicitacaoCompraService } from '../service/solicitacao-compra.service';
import { SolicitacaoCompraListaItem } from '../interface/solicitacao-compra';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-solicitacao-compra-lista',
  templateUrl: './solicitacao-compra-lista.component.html',
  styleUrl: './solicitacao-compra-lista.component.css'
})
export class SolicitacaoCompraListaComponent implements OnInit {

  tabelaPrincipalItens: Array<SolicitacaoCompraListaItem> = [];
  tabelaPrincipalFiltro: FiltroListaSolicitacaoCompra;
  tabelaPrincipalShowMoreDisable: boolean = true;
  tabelaPrincipalHeight: number =  window.innerHeight - 330;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  usuarioColumnsFilters: Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Solicitação de Compra'},
    ],
  };

  actionPage: Array<PoPageAction> = [
    {label: 'Nova Solicitação', action: this.novaSolicitacaoCompra.bind(this)},
    {label: 'Gerar Excel', action: this.gerarExcel.bind(this)},
  ]

  constructor(
    private router: Router,
    private excelService: ExcelService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private solicitacaoCompraService: SolicitacaoCompraService,
    private authService: AuthService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaSolicitacaoCompra(authService,'filtro-lista-solicitacao-compra');
    this.tabelaPrincipalFiltro.dados.order = 'C1_NUM desc'

  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;


  async ngOnInit() {
    this.tabelaPrincipalFiltro.init().then(()=>{
      this.advancedFilterActionModal();
    });
  }

  tabelaPrincipalLoad(zerarPaginacao: boolean):void{

    if (zerarPaginacao){
      this.tabelaPrincipalFiltro.dados.page = 1;
      this.tabelaPrincipalItens = [];
    } else {
      this.tabelaPrincipalFiltro.dados.page++;
    }

    this.tabelaPrincipalFiltro.postSalvarFiltro();

    this.solicitacaoCompraService.getSolicitacaoCompraLista(this.tabelaPrincipalFiltro.dados).subscribe({
      next: (lista) => {

        this.tabelaPrincipalShowMoreDisable = !lista.hasNext;

        this.tabelaPrincipalItens = this.tabelaPrincipalItens.concat(lista.items);

       }
    })

  }
  novaSolicitacaoCompra(): void{
    this.router.navigateByUrl(`compras/solicitacao-compra/crud`);
  }

  editarSolicitacaoCompra(row: SolicitacaoCompraListaItem): void{
    this.router.navigateByUrl(`compras/solicitacao-compra/crud/edit/${row.CC1NUM}`);
  }

  copiarSolicitacaoCompra(row: SolicitacaoCompraListaItem):void{
    this.router.navigateByUrl(`compras/solicitacao-compra/crud/copy/${row.CC1NUM}`);
  }



  async excluirSolicitacaoCompra(row: SolicitacaoCompraListaItem){

    if (!row.items){
      row.items =  (await firstValueFrom(this.solicitacaoCompraService.getSolicitacaoCompra(row.CC1NUM, {CSHOWDESCRICAO: 'S'}))).items;
    }

    if (row.items.filter(item=>item.NC1QUJE > 0).length === 0){
      this.poDialogService.confirm({
        title: 'Excluir Solicitação de Compra',
        message: `Deseja excluir a Solicitação de Compra (${row.CC1NUM}))?`,
        confirm: () => {
          this.solicitacaoCompraService.deleteSolicitacaoCompra(row.CC1NUM).subscribe({
            next: () => {
              this.tabelaPrincipalLoad(true);
            }
          });
        }
      })
    } else {
      this.poNotificationService.error({
        message: `A Solicitação de Compra (${row.CC1NUM}) NÃO pode ser excluída.`,
        duration: 5000,
      })
    }
  }

  async loadItensSolicitacao(row: SolicitacaoCompraListaItem) {
    if (!row.items){
      row.items =  (await firstValueFrom(this.solicitacaoCompraService.getSolicitacaoCompra(row.CC1NUM, {CSHOWDESCRICAO: 'S', CC1FORNECE: row.CC1FORNECE}))).items;
    }
  }

  showDetalhes():boolean{
    return true;
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CC1NUM'    , label: 'Código'      , width: '08%', visible: true},
    {property: 'CC1FORNECE', label: 'Fornecedor'  , width: '10%', visible: true},
    {property: 'CC1LOJA'   , label: 'Loja'        , width: '07%', visible: true},
    {property: 'CA2NOME'   , label: 'Razão Social', width: '30%', visible: true},
    {property: 'DC1EMISSAO', label: 'Emissão'     , width: '10%', visible: true, type: 'date'},
    {property: 'CC1SOLICIT', label: 'Solicitante' , width: '10%', visible: true},
  ]

  public tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Editar',  action: this.editarSolicitacaoCompra.bind(this),  icon: 'po-icon-edit' },
    { label: 'Copiar',  action: this.copiarSolicitacaoCompra.bind(this),  icon: 'po-icon-copy' },
    { label: 'Excluir', action: this.excluirSolicitacaoCompra.bind(this), icon: 'po-icon-delete' },
  ]

  public readonly tabelaSolicitacaoCompraColumns: Array<PoTableColumn> = [
    {property: 'CSITUACAO',label: 'Status',width: '7%', type: 'subtitle', visible: true,
      subtitles: [
        {value: 'B', color: 'color-01', content: 'B', label: 'Bloqueado'},
        {value: 'L', color: 'color-10', content: 'L', label: 'Liberado'},
        {value: 'R', color: 'color-07', content: 'R', label: 'Rejeitado'},
        {value: 'P', color: 'color-03', content: 'P', label: 'Parcialmente Atendido'},
        {value: 'F', color: 'color-12', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'CC1ITEM'   , label: 'Item'        , width: '08%', visible: true},
    {property: 'CC1PRODUTO', label: 'Produto'     , width: '10%', visible: true},
    {property: 'CC1DESCRI' , label: 'Descrição'   , width: '30%', visible: true},
    {property: 'CC1OBS'    , label: 'Observação'  , width: '30%', visible: true},
    {property: 'DC1DATPRF' , label: 'Necessidade' , width: '10%', visible: true , type: 'date'},
    {property: 'CC1UM'     , label: 'UM'          , width: '07%', visible: true},
    {property: 'NC1QUANT'  , label: 'Quantidade'  , width: '07%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'NC1QUJE'   , label: 'Já em PC'    , width: '07%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'CC1CC'     , label: 'Centro Custo', width: '10%', visible: true},
    {property: 'CC1CONTA'  , label: 'Cta Ctb'     , width: '10%', visible: true},

  ]

  goHome(): void {
    this.router.navigateByUrl('');
  }

  async gerarExcel() {
    const lista_excel: Array<any> = [];

    for (const sc of this.tabelaPrincipalItens) {
      if (!sc.items) {
        sc.items =  (await firstValueFrom(this.solicitacaoCompraService.getSolicitacaoCompra(sc.CC1NUM, { CSHOWDESCRICAO: 'S' }))).items;
      }

      for (const item of sc.items) {
        lista_excel.push({
          'Filial'      :  sc.CC1FILIAL,
          'Loja'        :  sc.CC1LOJA,
          'Código'      :  sc.CC1NUM,
          'Fornecedor'  :  `${sc.CC1FORNECE} - ${sc.CA2NOME}`,
          'Solicitante' :  sc.CC1SOLICIT,
          'Emissão'     :  moment(sc.DC1EMISSAO).locale('pt-br').format('DD/MM/YYYY'),
          'Item'        :  item.CC1ITEM,
          'Produto'     :  item.CC1PRODUTO,
          'Descrição'   :  item.CC1DESCRI,
          'Observação'  :  item.CC1OBS,
        });
      }

      lista_excel.push({}) // espacamento
    }

    this.excelService.exportAsExcelFile(lista_excel, `dados-solicitacao-compras`);
  }



  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad(true);
    },
    label: 'Aplicar Filtros'
  };

}
